import { render } from "./MediaIconEditorProps.vue?vue&type=template&id=0e4da459&scoped=true"
import script from "./MediaIconEditorProps.vue?vue&type=script&lang=js"
export * from "./MediaIconEditorProps.vue?vue&type=script&lang=js"

import "./MediaIconEditorProps.vue?vue&type=style&index=0&id=0e4da459&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4da459"]])

export default __exports__